type Translate = (key: string, values?: Record<string, string | number>) => string;

/**
 * Routes legacy next-i18next-style `ring-pro:` / `ring:` prefixed keys (still
 * used by the ring/ring-pro comparison, FAQ and colour-name data builders) to
 * the correct native next-intl namespace. next-intl has no namespace separator,
 * so a `t` scoped to one namespace echoes the raw key for the other — pass both
 * scoped functions and this strips the prefix and dispatches.
 *
 * Mirrors the inline shim in components/ring-pro/ComparisonSection. Remove once
 * the data builders drop the colon-prefixed key form.
 */
export const ringProKeyT =
  (tRing: Translate, tRingPro: Translate): Translate =>
  (key, values) =>
    key.startsWith('ring-pro:')
      ? tRingPro(key.slice('ring-pro:'.length), values)
      : key.startsWith('ring:')
        ? tRing(key.slice('ring:'.length), values)
        : tRing(key, values);
